import { useCallback, Dispatch, useRef, useEffect } from 'react';
import { useBrowser } from '../../../../common/services/BrowserService';
import { AutoCompleteResult } from './AutoComplete.styles';
import { PredictionType } from './PredictionType';

interface Props<T> {
  prediction: T;
  onChoose: Dispatch<T>;
  onHover: Dispatch<number>;
  isSelected: boolean;
  index: number;
}

const BAD_BROWSERS = ['IE', 'Edge'];

export const AutoCompletePrediction = <T extends PredictionType>(props: Props<T>) => {
  const { prediction, onChoose: onClick, onHover, index, isSelected } = props;
  const browser = useBrowser();
  const ref = useRef<HTMLDivElement>(null);
  const usingBadBrowser = useRef(BAD_BROWSERS.indexOf(browser.info.agent?.name ?? '') >= 0);
  const handleClick = useCallback(() => onClick(prediction), [onClick, prediction]);
  const handleHover = useCallback(() => onHover(index), [index, onHover]);

  useEffect(() => {
    // scrolls all the way to the top in edge and ie
    if (isSelected && !usingBadBrowser.current) ref.current?.scrollIntoView?.({ block: 'nearest' });
  }, [isSelected]);

  return (
    <AutoCompleteResult
      ref={ref}
      onMouseDown={handleClick}
      onMouseEnter={handleHover}
      aria-selected={isSelected}
      aria-label={prediction.label}
    >
      {prediction.label}
    </AutoCompleteResult>
  );
};
